import * as Sentry from '@sentry/browser';
import {describeContentShape} from './contentShape';

/** Which translator failed. Tagged so the two directions can be alerted on separately. */
export type ConversionDirection = 'draftjs-to-html' | 'html-to-draftjs';

/**
 * Reports a rich-text conversion failure, with the shape of the content but never the content.
 *
 * Task content is stored as DraftJS and the editor speaks HTML, so every task open
 * runs one translator and every blur runs the other. Neither reported failure before
 * this, which made the two most-travelled code paths in the editor the two least
 * visible ones.
 *
 * The company and rollout-cohort tags are already on the Sentry scope, so an event
 * raised here can be filtered to the canary without repeating them.
 */
export const reportConversionFailure = (
	direction: ConversionDirection,
	error: unknown,
	content: string | null | undefined
): void => {
	Sentry.captureException(error, {
		tags: {conversion: direction},
		contexts: {content: describeContentShape(content)},
	});
};
